import gql from "graphql-tag";

export const fetchCurrentPage = gql`
    query (
        $categories: String 
        $events_and_dates: String 
        $meetings_and_dates: String 
        $slug: String
        $region: String
        $trainings_and_dates: String 
        ) {
        page (
            categories: $categories
            events_and_dates: $events_and_dates
            meetings_and_dates: $meetings_and_dates
            slug: $slug
            region: $region
            trainings_and_dates: $trainings_and_dates
        ) {
            id
            name
            slug
            layout
            breadcrumbs {
                name
                slug
            }

            categories {
                id
                name
                slug 
                
                trainings {
                    id
                    name
                    link
                    north_america
				    europe
                }
            }

            meetings {
                name
                
                dates {
                    id
                    starts_at
                    next_session
                    north_america
                    is_available
                    europe

                    schedule {
                        name
                        name_euro
                    }

                    location {
                        name

                        city {
                            name
                        }
                    }

                    type {
                        id
                        name
                    }
                }
            }
            
            sections {
                key
                name
                title
                lead
                text
                has_video
                vimeo
                youtube
                is_active

                atoms {
                    address
                    cta
                    cta_link
                    duration
                    max_attendees
                    page_id
                    preliminary
                    price
                    region
                    slug
                    text
                    title
                    is_active
                }

                articles {
                    author
                    name
                    published_at
                    published_in
                    link
                    type
                }

                books {
                    id
                    author
                    image_link
                    lead
                    link
                    name
                    is_active
                }
                
                events {
                    id
                    link
                    name
                    slug
                    registration_fee
                    registration_fee_euro
                    price
                    price_euro
                    north_america
                    europe
                    
                    dates {
                        starts_at
                        next_session
                        north_america
                        is_available
                        europe
                        is_on_2_days
                            
                        location {
                            id
                            name
                        }
                        
                        schedule {
                            id
                            name
                            name_euro
                        }

                        type {
                            id
                            name
                            slug
                        }
                    }
                    
                    type {
                        id
                        name
                        slug
                    }				
                }

                trainings {
                    id
                    name
                    meta_title
                    link
                    slug
                    uec

                    registration_fee
                    registration_fee_euro
                    session_price
                    session_price_euro
                    total
                    total_euro
                    north_america
                    europe
                    
                    dates {
                        starts_at
                        next_session
                        is_available
                        is_on_2_days

                        north_america
                        europe
                        
                        location {
                            id
                            name
                        }
                        
                        schedule {
                            id
                            name
                            name_euro
                        }

                        type {
                            id
                            name
                            slug
                        }
                    }
                    
                    category {
                        id
                        name
                        slug
                    }				
                }

                team {
                    id

                    type { 
                        id
                        name
                        section
                    }

                    category
                    photo
                    firstname
                    lastname
                    position
                    region
                    bio
                    linkedin
                    is_active
                }

                testimonial {
                    name
                    description
                    text
                }
                
                ctas {
                    page_id
                    label
                    slug
                    text
                    url
                }
            }

            event {
                id
                name
                link
                slug
                text
                duration
                for_who
                registration_fee
                registration_fee_euro
                price
                price_euro
                north_america
                europe
			
                animator {
                    fullname
                    text
                    position
                }
                
                dates {
                    id
                    starts_at
                    next_session
                    attendees
                    max_attendees
                    is_available
                    is_on_2_days

                    north_america
                    europe
                    
                    location {
                        id
                        name

                        city {
                            id
                            name
                        }
                    }
                    
                    schedule {
                        id
                        name
                        name_euro
                    }

                    type {
                        id
                        name
                        slug
                    }
                }
                
                category {
                    id
                    name
                    slug
                }	
                
                type {
                    id
                    name
                    slug
                }				
            }

            events {
                id
                name
                link
                slug
                registration_fee
                registration_fee_euro
                price
                price_euro
                north_america
                europe
                
                dates {
                    id
                    starts_at
                    next_session
                    north_america
                    is_available
                    europe
                    is_on_2_days
                    
                    location {
                        id
                        name

                        city {
                            id
                            name
                        }
                    }
                    
                    schedule {
                        id
                        name
                        name_euro
                    }

                    type {
                        id
                        name
                        slug
                    }
                }
                
                category {
                    id
                    name
                    slug
                }	
                
                type {
                    id
                    name
                    slug
                }				
            }

            training {
                id
                name
                meta_title
                link
                slug
                duration
                course_duration
                objectives
                vimeo
                youtube
                themes
                structure
                prerequisites
                registration
                admission
                certification
                uec

                registration_fee
                registration_fee_euro
                session_price
                session_price_euro
                interview
                interview_euro
                integration
                integration_euro
                option_supervision
                option_supervision_euro
                option_cocounsel
                option_cocounsel_euro
                option_summary
                option_summary_euro
                total
                total_euro
                tax_credits
                north_america
                europe
                
                dates {
                    id
                    group
                    calendar
                    attendees
                    max_attendees
                    starts_at
                    next_session
                    is_available
                    north_america
                    europe
                    is_on_2_days
                    
                    location {
                        id
                        name

                        city {
                            id
						    name
                        }
                    }
                    
                    schedule {
                        id
                        name
                        name_euro
                    }

                    type {
                        id
                        name
                        slug
                    }
                }
                
                category {
                    id
                    name
                    slug
                }				
            }

            trainings {
                id
                name
                meta_title
                link
                slug
                duration
                course_duration
                objectives
                themes
                vimeo
                youtube
                structure
                prerequisites
                registration
                admission
                certification
                uec

                registration_fee
                registration_fee_euro
                session_price
                session_price_euro
                interview
                interview_euro
                integration
                integration_euro
                option_supervision
                option_supervision_euro
                option_cocounsel
                option_cocounsel_euro
                option_summary
                option_summary_euro
                total
                total_euro
                tax_credits
                north_america
                europe
                
                dates {
                    id
                    group
                    calendar
                    attendees
                    max_attendees
                    starts_at
                    next_session
                    is_available
                    north_america
                    europe
                    is_on_2_days
                    
                    location {
                        id
                        name

                        city {
                            id
						    name
                        }
                    }
                    
                    schedule {
                        id
                        name
                        name_euro
                    }

                    type {
                        id
                        name
                        slug
                    }
                }
                
                category {
                    id
                    name
                }				
            }
        }
    }
`;

export const fetchPageBySlug = gql`
    query (
        $slug: String
        $trainings_and_dates: String
        $region: String
    ) {
        page (
            slug: $slug
            trainings_and_dates: $trainings_and_dates
            region: $region
        ) {
            name
            slug

            trainings {
                id
                name
                slug

                registration_fee
                registration_fee_euro
                session_price
                session_price_euro
                interview
                interview_euro
                integration
                integration_euro
                option_supervision
                option_supervision_euro
                option_cocounsel
                option_cocounsel_euro
                option_summary
                option_summary_euro
                total
                total_euro
                tax_credits	

                dates {
                    id
                    group
                    calendar
                    attendees
                    max_attendees
                    starts_at
                    next_session
                    is_available
                    north_america
                    europe
                    
                    location {
                        id
                        name

                        city {
                            id
						    name
                        }
                    }
                    
                    schedule {
                        id
                        name
                        name_euro
                    }

                    type {
                        id
                        name
                        slug
                    }
                }		
            }
        }
    }
`;

export const fetchEmployee = gql`
    query (
        $category: String
        $slug: String
        ) {
        fetchEmployee (
            category: $category
            slug: $slug
        ) {
            fullname
            position
            bio
            linkedin
            photo
        }
    }
`;

export const fetchArticlesPage = gql`
    query (
        $slug: String
        $limit: Int
        ) {
        page (
            slug: $slug
            limit: $limit
        ) {
            id
            name
            slug
            layout
            
            sections {
                key
                name
                title
                lead
                text

                articles {
                    author
                    name
                    published_at
                    published_in
                    uri
                    type
                }
            }
        }
    }
`;

export const fetchArticlePage = gql`
    query (
        $slug: String
        ) {
        article (
            slug: $slug
        ) {
            author
            lead
            name
            published_at
            published_in
            text
        }
    }
`;